import React, { useState } from "react";

const ModuleFaq = ({ faq, label }) => {
  const [openSet, setOpenSet] = useState(() => new Set([0]));
  if (!faq?.length) return null;

  const toggle = (idx) => {
    setOpenSet((prev) => {
      const next = new Set(prev);
      if (next.has(idx)) next.delete(idx);
      else next.add(idx);
      return next;
    });
  };

  return (
    <section className="mk-section soft" data-testid="module-section-faq">
      <div className="mk-wrap">
        <div className="mk-section-head mk-reveal">
          <div>
            <h2>Questions fréquentes - {label}</h2>
          </div>
        </div>
        <div className="mk-faq">
          {faq.map((item, idx) => {
            const isOpen = openSet.has(idx);
            return (
              <div key={item.q} className={`mk-faq-item mk-reveal${isOpen ? " open" : ""}`}>
                <button
                  type="button"
                  className="mk-faq-q"
                  aria-expanded={isOpen}
                  onClick={() => toggle(idx)}
                >
                  {item.q}
                  <span className="mk-faq-toggle" aria-hidden="true">{isOpen ? "−" : "+"}</span>
                </button>
                <div className="mk-faq-a"><p>{item.a}</p></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ModuleFaq;
